import { PocComponentHeader } from 'commons/components/components-wrapper/poc-component-header.component';
import { PocDivider } from 'commons/components/components-wrapper/poc-divider.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import { Rule } from 'modules/settings/pods/settings-automation-rules/types/automation-rules.type';
import { EntityToggleListItem } from 'modules/settings/pods/settings-automation-rules/ui-components/entity-toggle-list-item.component';
import React from 'react';
import { SettingsCardLayout } from 'modules/settings/settings.style';

interface AutomationRulesListComponentProps {
    rules: Rule[];
    onEnableChange: (id: string) => void;
    onEditOptionHandler: (id: string) => void;
}

export const AutomationRulesListComponent: React.FC<AutomationRulesListComponentProps> = (props) => {
    const { t } = useTranslation();
    const { rules, onEditOptionHandler, onEnableChange } = props;

    return (
        <SettingsCardLayout rounded>
            <PocComponentHeader slot="header" style={{ paddingTop: '12px' }}>
                <PocTypography element="h6" variant="title6">
                    {t('settings.system.automation-rules.list.table.title', { total: rules.length })}
                </PocTypography>
            </PocComponentHeader>
            <>
                {rules.length ? (
                    rules?.map((rule, index) => (
                        <React.Fragment key={rule.name}>
                            {!!index && <PocDivider key={`custom-divider-${rule.id}`} />}
                            <EntityToggleListItem
                                key={`automation-rule-${rule.id}`}
                                id={rule.id}
                                name={rule.name}
                                enabled={rule.enabled}
                                onEnabledChange={onEnableChange}
                                onEdit={onEditOptionHandler}
                            />
                        </React.Fragment>
                    ))
                ) : (
                    <PocTypography element="p" variant="body1">
                        {t('settings.system.automation-rules.fields.type.empty_state')}
                    </PocTypography>
                )}
            </>
        </SettingsCardLayout>
    );
};
